import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation PinPost($objectId: ID!) {
    pinPost(objectId: $objectId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
